// api/axiosClient.js
import axios from 'axios';
import queryString from 'query-string';
import {
  ARR_USER_ROLES,
  SESSION_EXPIRY,
  TEMP_USER_TOKEN,
  USER_TOKEN,
  USER_VIEW_MODE,
} from 'helpers/storage';
import { API_BASE_URL } from 'config';
import m from 'moment-timezone';
import { deleteCookie } from 'cookies-next';
// Set up default config for http requests here

// Please have a look at here `https://github.com/axios/axios#request-
// config` for the full list of configs

const axiosClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'content-type': 'application/json',
  },
  paramsSerializer: (params) => queryString.stringify(params),
});

axiosClient.interceptors.request.use(async (config) => {
  // check sever side
  if (typeof window !== 'undefined') {
    // Handle token here ...
    const token = config?.token || TEMP_USER_TOKEN.get() || USER_TOKEN.get();
    const role = USER_VIEW_MODE.get();
    if (token && !config?.noAuth) {
      config.headers.Authorization = token;
      if (role) {
        config.headers.Role = role;
        config.headers.TimeZone = m.tz.guess();
      }
    }
    // config formData
    if (config?.data instanceof FormData) {
      config.headers['Content-Type'] = 'multipart/form-data';
    }
  }
  return config;
});

axiosClient.interceptors.response.use(
  (response) => {
    if (response?.data?.payload) {
      return response.data.payload;
    }

    if (response?.data) {
      return response.data;
    }

    return response;
  },
  async (error) => {
    if (error?.response?.status == 401) {
      await USER_TOKEN.delete();
      await USER_VIEW_MODE.delete();
      await ARR_USER_ROLES.delete();
      await TEMP_USER_TOKEN.delete();
      SESSION_EXPIRY.delete();
      deleteCookie('USER_TOKEN');
      deleteCookie('userViewMode');
      deleteCookie('tempUserToken');
      // store.dispatch(logout());
      window.location.replace('/home');
      return;
    }

    throw error;
  },
);
export default axiosClient;
